import { useTranslation } from 'react-i18next';
import { QcsTableCell } from '../common/basic/QcsTableCell';
import { CellDate } from '../common/grid/CellDate';
import { AccessPointLogDto } from '@api/models/AccessPointLogDto';
import { Grid } from '../common/grid/Grid';
import { useNavigate } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../store';
import { CancelToken } from 'axios';
import { getTurnstileLogsList, selectTurnstileLogsList, turnstileLogsListActions } from '../../store/entities/turnstileLogsList';
import { DetailHeader } from '../common/DetailHeader';
import { useBack } from '../../hooks/useBack';
import { formatDate } from '../../utils/date';

export const VisitationTurnstileLogs = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const logs = useAppSelector(selectTurnstileLogsList);
  const { backTo } = useBack('/visitation');

  const handleRowClick = (item: AccessPointLogDto) => {
    navigate(`/supplier/${item.supplierEmployee?.supplier?.id}/employee/${item.supplierEmployee?.id}`);
  };

  const handleRenderData = (item: AccessPointLogDto) => {
    return (
      <>
        <QcsTableCell>{item.supplierEmployee?.name + ' ' + item.supplierEmployee?.lastName}</QcsTableCell>
        <QcsTableCell>
          {t(`visitation.accessPointLog.reasons.${item.statusCode}`)}
          {item.detailedStatusCode?.length > 0 && (
            <>
              :
              <br />
              <ul style={{ paddingLeft: '1rem' }}>
                {item.detailedStatusCode?.map((code, index) => {
                  const parameters = code.parameters?.dateTime
                    ? { ...code.parameters, dateTime: formatDate(i18n, code.parameters.dateTime, true, true) }
                    : code.parameters;

                  return (
                    <li key={index}>
                      {code.actionRequiredFrom && <strong>{t(`visitation.accessPointLog.${code.actionRequiredFrom.toLowerCase()}`)}: </strong>}
                      {t(`errorCodes.${code.code}`, parameters)}
                    </li>
                  );
                })}
              </ul>
            </>
          )}
        </QcsTableCell>
        <CellDate value={item.timestamp} showWithTime={true} showSeconds={true} />
      </>
    );
  };

  const handleGetData = (cancelToken: CancelToken) => {
    dispatch(getTurnstileLogsList(cancelToken));
  };

  const handleRefresh = (cancelToken: CancelToken) => {
    dispatch(turnstileLogsListActions.reload(true));
    handleGetData(cancelToken);
  };

  return (
    <>
      <DetailHeader title="visitation.accessPointLog.title" backTo={backTo} onRefresh={handleRefresh} />
      <Grid<AccessPointLogDto>
        headers={[
          {
            captionStr: 'visitation.supplierEmployee',
            orderName: 'supplierEmployee',
          },
          {
            captionStr: 'visitation.accessPointLog.message',
          },
          {
            captionStr: 'visitation.accessPointLog.timestamp',
            orderName: 'timestamp',
          },
        ]}
        data={logs}
        gridActions={turnstileLogsListActions}
        renderData={handleRenderData}
        onRowClick={handleRowClick}
        getData={handleGetData}
      />
    </>
  );
};
